import Choices from 'choices.js';
import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['select'];

  initialize() {
    new Choices(this.selectTarget, { itemSelectText: '', searchResultLimit: 10 });
    this.selectTarget.addEventListener('change', this.changeHandler.bind(this));
  }

  changeHandler(event) {
    this.container && xhrRequest(event.detail.value, 'get').then(({ data }) => {
      App.Helpers.replaceElement(this.container, data);
    });
  }

  //
  // GETTERS AND SETTERS
  //

  get container() {
    return document.querySelector(this.data.get('container-selector'));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/company-settings-select-controller.js